import { codeSplit, Controller, FetchOptions, Result } from 'bernie-core';

export class AuthCallbackController implements Controller {
  public routeName = 'authcallback';
  public pageId = 'pages.authcallback';
  public path = '/auth/callback';
  public exact = true;
  public bundles = [];

  public component = codeSplit(() => import(/* webpackChunkName: "auth-callback" */ '../views/auth-callback'));

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    return Promise.resolve({});
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData() {
    return Promise.resolve({ title: '' });
  }
}
